export const isNewStore = (createdAt: string | undefined): boolean => {
  if (!createdAt) return false;

  const storeDate = new Date(createdAt);
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  return storeDate >= sixMonthsAgo;
};
